import * as React from 'react';
import { useEffect, useState } from 'react';
import farnell from "src/assets/images/farnell.png";
import { AddPartAutoComplete } from 'src/reusable/product';
import { system_notification } from 'src/store/slice/system';
import store from 'src/storeWire';
import { useBOMStore } from "../../../../hooks/bom";
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import Common from '../../Common';
import { useSearchParams } from 'react-router-dom';
import BOM from "@system/config/bom";
import BomHealthIndicator from './BomHealthIndicator';
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import { Tooltip } from 'src/component/Tooltip';
import Constants from 'src/support/Constants';
import { useCartStore } from 'src/hooks/cart';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import Cookies from 'js-cookie';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';
import { useBOMProjectStore } from 'src/hooks/bom_project';
import Helper from 'src/support/Helper';
import liveAuth from 'src/helper/liveAuth';

const BomTabsData = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [searchParams] = useSearchParams();
    const [{ bom_detail_by_bom_id_type, bom_detail_by_bom_id, bom_health_by_bom_id }, { get_bom_detail_by_bom_id, get_bom_health_by_bom_id, get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui }, { add_part_to_bom, set_is_rematch_flag }] = useBOMStore();
    const [productSelected, setProductSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
    const [searchTerm, setSearchTerm] = useReduxState('', 'setAutoCompleteSearchTerm')
    const [BomTabList__Component__Loader] = useReduxState(searchParams.get(Common.param_key_BomTabList) ? searchParams.get(Common.param_key_BomTabList) : Common.default_component_BomTabList.param_value, Common.redux_key_BomTabList, 'BomTabList__Component__Loader');
    const [{ CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const avUserInfo = liveAuth.getAvUserInfo();

    // Check if Email and Download should be hidden for external users with Design hub source
    const isExternalUser = Helper.validateDomain(avUserInfo?.email);
    const source = bom_detail_by_bom_id?.source?.toLowerCase()?.trim();
    const isDesignHub = source === 'design hub';
    const shouldHideEmailDownload = isExternalUser && isDesignHub;


    const [displayBomHealthButton, setDisplayBomHealthButton] = useState(true)
    const [fernrllFormData, setFernrllFormData] = useState({})
    const bom_id = System.getParams().bomId;
    const [checkoutFarnellClick, setCheckoutFarnellClick] = useReduxState(false, 'setCheckoutFarnellClick')
    const [farnellToggleButton, setFarnellToggleButton] = useReduxState(false, 'farnellToggleButton')
    const [showFarnallPopup, setShowFarnallPopup] = useState(Cookies.get("bomFarnelToggle") === "true" ? true : false)
    const url = System.getFarnellURL() + System.getFarnellCMPUrl();
    const [{ bom_project_list }, { }, { }] = useBOMProjectStore();

    useEffect(() => {
        if (!localStorage.getItem(bom_id)) {
            localStorage.setItem(bom_id, true)
        } else {
            localStorage.removeItem(bom_id)
        }
    }, [])

    useEffect(() => {
        if (checkoutFarnellClick) {
            setCheckoutFarnellClick(false)
            let button = document.getElementById("farnellsubmit");
            console.log('Farnell Form Data - ', fernrllFormData)
            button.click();
        }
    }, [checkoutFarnellClick])

    useEffect(() => {
        setDisplayBomHealthButton(true)
        if (bom_detail_by_bom_id_type?.Exact?.count > 0) {
            setFernellFormData()
        }
    }, [bom_detail_by_bom_id_type?.Exact?.count])

    const setFernellFormData = () => {
        if (bom_detail_by_bom_id_type.Exact.records && Object.entries(bom_detail_by_bom_id_type.Exact.records).length > 0) {
            let params = [];
            Object.entries(bom_detail_by_bom_id_type.Exact.records).map((v) => {
                params.push({
                    MANUFACTURER_PID: v[1].manufacturerPartNumber,
                    QUANTITY: v[1].quantity.toString(),
                    SUPPLIER_ID_DUNS: 'Avnet'
                })
            });
            let formObj = { "ITEM": params }
            setFernrllFormData(JSON.stringify(formObj))
        }
    }

    useEffect(() => {
        async function fetchHere() {
            if (Object.entries(productSelected).length > 0) {
                const customerPartNumber = CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[productSelected?.ItemNumber]?.CUSTOMER_PART_NUMBER;
                let params = {}
                params.ERPPartNumber = productSelected.ERPPartNumberModified ? '' : productSelected.ERPPartNumber
                params.ManufacturerPartNumber = productSelected.ManufacturerPartNumber
                params.ItemNumber = productSelected.ItemNumber
                params.quantity = productSelected.QtyMin
                params.LifeCycleRisk = productSelected.LifeCycleRisk
                params.bomIds = [bom_id]
                params.fromCart = false
                params.ERPMFRPartNumber = productSelected.ERPMFRPartNumber
                params.cpnType = productSelected?.CustomerPartNumbers?.length > 0 ? Constants.cpnTypes.CPN : Constants.cpnTypes.MANUALCPN
                params.manualCPN = ''

                if (productSelected.selectedSearchCPN) {
                    params.CUSTOMER_PART_NUMBER = productSelected.selectedSearchCPN
                    params.cpn = productSelected.selectedSearchCPN
                }
                if (productSelected?.CustomerPartNumbers?.length > 0) {
                    params.cpnType = Constants.cpnTypes.CPN
                    params.customerPartNumber = customerPartNumber
                }

                // if (productSelected?.CustomerPartNumbers.length > 0) {
                //     params.cpnType = Constants.cpnTypes.CPN
                //     params.customerPartNumber = customerPartNumber
                // } else {
                //     params.cpnType = Constants.cpnTypes.MANUALCPN
                //     params.manualCPN = ''
                // }
                await add_part_to_bom(params).then(async (res) => {
                    if (res) {
                        setProductSelected({})
                        setSearchTerm('')
                        await get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui(bom_id, true)

                        if (BomTabList__Component__Loader !== 'BomExactMatchTable') {
                            System.alert('The part has been successfully added to the exact match tab. Please go to Exact Match tab and scroll down to find the added part.');
                        }
                    }
                })
            }
        }

        fetchHere()
    }, [productSelected]);


    const checkBomHealth = async () => {
        await get_bom_health_by_bom_id({ bomId: bom_id })
        setDisplayBomHealthButton(false)
        bomHealthCTA();
    };

    // code added by Ramya
    const bomHealthCTA = () => {
        let linkDetails = {
            linkName: "Check bom health",
            linkUrl: window.location.href,
            linkLocation: window.document.title,
            linkType: "Button",
            linkComponent: "BOM Page",
        }
        localStorage.setItem("adobeEventType", "CTAClickEvent");
        HelperAdobeEvent.trackingAdobeEvent({
            linkDetails
        })
    }

    const renderTooltip = (props) => (
        <div>
            LOW RISK:
            Part listed as active by Manufacturer. Suitable for new and existing designs.

            MEDIUM RISK:
            Part not confirmed as active by Manufacturer. Presents increased risk of obsolescence. Exercise caution in using for a new design.

            HIGH RISK:
            Part identified as End Of Life (EOL) or obsolete by Manufacturer. Select an alternative from the list on part detail page,or use part attribute filters to find alternative parts.
        </div>
    );


    const onFarnelPopupClick = () => {
        Cookies.set("bomFarnelToggle", "true");
        setShowFarnallPopup(true);
    };

    const bomSwitchToFarnellEvent = (event) => {
        const bomInfo = {
            bomId: bom_detail_by_bom_id?.bomId,
            bomTitle: bom_detail_by_bom_id?.bomName,
            bomProjectName: bom_project_list[bom_detail_by_bom_id?.projectId]?.projectName || '',
            exactMatchesReturned: bom_detail_by_bom_id_type?.Exact?.count,
            multipleMatchesReturned: bom_detail_by_bom_id_type?.Multiple?.count,
            noMatchesReturned: bom_detail_by_bom_id_type?.NoMatch?.count,
            newBOM: bom_detail_by_bom_id?.newBOM,
            sourceOfBOM: bom_detail_by_bom_id?.source
        }
        HelperAnalyticsEvent.bomSwitchToFarnell({ selectedSite: event, bomInfo: bomInfo })
    }

    const toggleFarnellOnOff = (e) => {
        setFarnellToggleButton(e)
        bomSwitchToFarnellEvent(e ? 'Farnell' : 'Avnet');
    }
    return (
        <>
            {__check(['BOM_REMATCH_FLAG_OPERATION_API_CALL']).render}
            {!__check(['BOM_REMATCH_FLAG_OPERATION_API_CALL']).status &&
                <></>
            }

            {bom_detail_by_bom_id.isRematched !== undefined && bom_detail_by_bom_id.isRematched === false && !farnellToggleButton &&
                <div className="alert alert-dark justify-content-center m-b-15">
                    <span className="font-16 font-bold text-black-stone me-1">Have we defined your columns correctly?
                        <a
                            href={void (0)}
                            onClick={async () => {
                                await set_is_rematch_flag({ bomId: bom_id });
                                await get_bom_detail_by_bom_id({ bomId: bom_id });
                            }} className="text-blue2 ms-1 me-1">YES</a>
                        |
                        <a href={BOM.getBomRematchRouteURL({ bomId: bom_id })} className="text-blue2 ms-1">NO</a>,
                        <a href={BOM.getBomRematchRouteURL({ bomId: bom_id })}
                            className="text-blue2 ms-1">Redefine Columns</a></span>
                </div>
            }



            <div className="overall-bom-header mb-3 mb-lg-0 mt-4">
                <div className="overall-bom-left">
                    <h1 className='font-oswald font-light mobile-title mt-0'>{farnellToggleButton ? 'Farnell' : 'Avnet'} BOM Details</h1>
                    {farnellToggleButton ?
                        <p>You are viewing the  <b>low volume pricing</b> and <b>availability</b> from our sister company – Farnell,  if you want higher volume pricing please use the toggle to view Avnet stock.</p>
                        :
                        <p>You are viewing the <b>high volume pricing</b> and <b>availability</b> from Avnet,  if you want lower volume pricing and availability please use the toggle to view Farnell stock.</p>
                    }

                    {!__check(['BOM_SAVE_PREFERENCE_API_CALL', 'BOM_TAB_API_CALL']).status && (

                        bom_detail_by_bom_id_type && bom_detail_by_bom_id_type.isExternalBom &&
                        <>
                            <div className={!showFarnallPopup ? 'farnell-overlay' : ''}></div>
                            <div className='mt-2 position-relative'>

                                {!showFarnallPopup &&
                                    <div className='farnell-popup'>
                                        <b className='font-arial'> Need Smaller Quantities ?</b>
                                        <p>
                                            View prototype quantities from Farnell, an Avnet sister company, by using the toggle button to switch between Avnet and Farnell Bom details.</p>
                                        <div className='text-end'>
                                            <button onClick={onFarnelPopupClick} className='bs5 btn btn-primary'>close</button>
                                        </div>
                                    </div>}
                                Switch between  Avnet and Farnell BOM details:
                                <div className='d-flex align-items-center mt-3 bom-farnell-switch'>
                                    <div className={farnellToggleButton ? '' : 'active'}>Avnet</div>
                                    <label className="switch farnell-switch">
                                        <input
                                            type="checkbox"
                                            checked={farnellToggleButton}
                                            onClick={(e) => (toggleFarnellOnOff(e.target.checked))}
                                        />
                                        <span className="slider round"></span>

                                    </label>
                                    <div className={farnellToggleButton ? 'active' : ''}>Farnell</div>
                                </div>
                            </div></>)}

                    {!farnellToggleButton &&
                        <>
                            <div className="d-flex align-items-center mb-3 flex-wrap mt-3">
                                <h5 className="me-2 mt-0"><span className='me-1 text-black'>Exact Match BOM Health</span>
                                    <Tooltip
                                        position={'bottom center'}
                                        opener={() => (
                                            <i className="fa fa-info-circle font-15"></i>
                                        )}
                                        content={() => (
                                            renderTooltip()
                                        )}
                                    />

                                </h5>
                                {__check('BOM_HEALTH_API_CALL', {
                                    inline: true
                                }).render}
                                {!__check(['BOM_HEALTH_API_CALL']).status && displayBomHealthButton &&
                                    <button className="bs5 btn btn-secondary me-4"
                                        onClick={async () => {
                                            await checkBomHealth()
                                        }}
                                    >check bom health
                                    </button>
                                }

                                {!displayBomHealthButton &&
                                    <ul className="list-unstyled list-inline m-0">
                                        <BomHealthIndicator
                                            bom_health_by_bom_id={bom_health_by_bom_id}
                                        />
                                    </ul>
                                }

                            </div>

                            {/**
                     * CR 9924 display conditionally based on isExternalBom flag
                     * Author: Devanshi Patel
                     */}

                            {!__check(['BOM_SAVE_PREFERENCE_API_CALL', 'BOM_TAB_API_CALL']).status && (

                                bom_detail_by_bom_id_type && !bom_detail_by_bom_id_type.isExternalBom && !shouldHideEmailDownload &&
                                <div className="mb-3 mb-md-0">
                                    Need prototype quantities?
                                    {bom_detail_by_bom_id_type && Object.entries(bom_detail_by_bom_id_type).length > 0 &&
                                        bom_detail_by_bom_id_type.totalMatches < 201 ? (
                                        <a href={void (0)}
                                            className="font-bold text-blue2"
                                            onClick={() => {
                                                store.dispatch(system_notification({
                                                    name: 'DownloadBomPopup',
                                                    data: [],
                                                }));
                                            }}> Download your BOM </a>
                                    ) : (
                                        <Tooltip
                                            position={'bottom center'}
                                            opener={() => (
                                                <span>
                                                    <a href={void (0)}
                                                        className="font-bold text-blue2"
                                                        onClick={() => {
                                                            store.dispatch(system_notification({
                                                                name: 'DownloadBomPopup',
                                                                data: {
                                                                    isEmailPopup: 'yes'
                                                                },
                                                            }));
                                                        }}> Email your BOM </a>
                                                </span>
                                            )}
                                            content={() => (
                                                <div>
                                                    Download is limited to BOMs with 200 items or less.
                                                    You can still email this BOM using the Email button.
                                                </div>
                                            )}
                                        />
                                    )} and
                                    {/**
                                 * CR #      : 10256
                                 * Change #  : Import farnell url change
                                 * Change by : Pankaj
                                 * Date      : 16 May 2023
                                 */
                                    }
                                    <a href="https://export.farnell.com/webapp/wcs/stores/servlet/BOMDisplayView?CMP=EMEA-AVNET-ESPOT" target="_blank" className="font-bold text-blue2"
                                    > Import at Farnell. </a>
                                    <img className="img-fluid" src={farnell} />
                                </div>

                            )}
                        </>
                    }
                </div>

                {!farnellToggleButton &&
                    <div className="overall-bom-right ms-0 ms-lg-auto">
                        <div className="d-flex align-items-center">
                            <label className="font-14 font-bold me-3 my-0">Quickly Add a Part</label>
                            {/**
                         * isPriceInventoryCall is used for reduce price and inventory call if it's false then not calling API
                         * Author: Devanshi Patel
                         */}
                            <AddPartAutoComplete isPriceInventoryCall={false} />
                        </div>
                        <div className="add-part-links">
                            <a className="add-part-link text-blue2" href={void (0)} data-toggle="modal"
                                data-target="#add-parts"
                                onClick={() => {
                                    store.dispatch(system_notification({
                                        name: 'CreatePartPopup',
                                        data: {
                                            title: "Add multiple parts",
                                            addFrom: "AddPart"
                                        },
                                    }));
                                }}>Add Multiple Parts</a>
                            <a className="add-part-link text-blue2" href={void (0)}
                                onClick={() => {
                                    store.dispatch(system_notification({
                                        name: 'FindPartPopup',
                                        data: {
                                            title: "Add multiple parts",
                                            addFrom: "FindPart"
                                        },
                                    }));
                                }}>FInd a Part</a>
                            {bom_detail_by_bom_id_type.bomColumnMapping && Object.entries(bom_detail_by_bom_id_type.bomColumnMapping).length > 0 &&
                                <a className="add-part-link text-blue2" href={void (0)}
                                    onClick={() => {
                                        store.dispatch(system_notification({
                                            name: 'BomEditColumnsPopup',
                                            data: [],
                                        }));
                                    }}>Add/edit columns</a>
                            }
                        </div>
                    </div>
                }
            </div>

            {localStorage.getItem(bom_id) && !farnellToggleButton &&
                <p className="font-18 mb-0"><b>{bom_detail_by_bom_id_type.totalMatches}</b> items imported successfully,
                    checking matching
                    in tabs</p>
            }

            <form className="d-none" encType="application/x-www-form-urlencoded" target="_blank"
                // action={`https://uk.farnell.com/PFConfigurator?&type=AVNET&langId=44&CMP=${System.getFarnellCMPUrl()}`}
                action={url}
                id="farnellcart" method="post" name="farnellcart" >
                <input id="result" name="result"
                    value={fernrllFormData}
                // value="{&quot;ITEM&quot;:[{&quot;MANUFACTURER_PID&quot;:&quot;1N4448W-E3-08&quot;,&quot;QUANTITY&quot;:&quot;1&quot;,&quot;SUPPLIER_ID_DUNS&quot;:&quot;Avnet&quot;}]}"
                />
                <input type="submit" value="Farnell Cart" id="farnellsubmit" />
            </form>
        </>
    );
}

export default BomTabsData;